import moment from "moment";
const defaultRender = (value) => (value  ? value : '--');

const lpCloseTradeColumns = (page = 1, pageSize = 10) => [
  {
    title: "No.",
    key: "no",
    render: (_, __, index) => (page - 1) * pageSize + index + 1,
  },
  {
    title: "Deal",
    dataIndex: "deal",
  },
  {
    title: "Position Id",
    dataIndex: "positionID",
  },
  {
    title: "Order",
    dataIndex: "order",
  },
  {
    title: "Symbol",
    dataIndex: "symbol",
  },
  {
    title: "Price",
    dataIndex: "price",
    render:defaultRender,
  },
  {
    title: "Price SL",
    dataIndex: "priceSL",
    render: defaultRender,
  },
  {
    title: "Price TP",
    dataIndex: "priceTP",
    render: defaultRender,
  },
  {
    title: "Volume",
    dataIndex: "volume",
  },
  {
    title: "PNL",
    dataIndex: "profit",
    render: (text) => text > 0 ? <span className="text-[#28C76F] font-semibold" >$ {text}</span> : <span className="text-[#FF4C51] font-semibold" >$ {text}</span>
  },
  {
    title: "Market Ask",
    dataIndex: "marketAsk",
    render: defaultRender,
  },
  {
    title: "Market Bid",
    dataIndex: "marketBid",
    render: defaultRender,
  },
  {
    title: "Profit Rate",
    dataIndex: "rateProfit",
    render: defaultRender,
  },
  {
    title: "Margin Rate",
    dataIndex: "rateMargin",
    render: defaultRender,
  },
  {
    title: "Close Time",
    dataIndex: "time",
    render: (text) => text ? moment(text).format("DD-MM-YYYY h:mm A") : "--",
  },
  {
    title: "Comment",
    dataIndex: "comment",
    render: (text) => (text === "" ? "--" : text),
  },
];

export default lpCloseTradeColumns;
